import React, { useEffect } from 'react';

const Message = (props) => {
    const { success } = props;

    useEffect(() => {
        if (success){
            setTimeout(() => {
                window.location.href = window.origin + `/minhaconta`;
            }, 4000)
        }
    }, [success])

    // if (error){
    //     return (
    //         <div className="modal3">
    //             <h2>
    //                 Algo deu <span>errado</span>
    //             </h2>
                
    //             <img src={sadEmoji} alt="" />
                
    //             <h5>
    //                 Que tal <span onClick={() => goToStep(1)}>tentar de novo</span>?
    //             </h5>
                
    //             <p>
    //                 Talvez voc&ecirc; tenha deixado a janela aberta e esquecido da
    //                 transfer&ecirc;ncia...
    //             </p>
    //       </div>
    //     )
    // }

    return (
    <div className="message-coupon" style={{ backgroundColor: "#68ffbf" }}>
        <span style={{ color: "#126C46" }}>
        Assinatura concluida!
        </span>
    </div>

    )
}

export default Message
